import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  /**
  * store in in localstorage
  * encruption enabled
  * @param {JSON} data
  */
  public storeLoginData(data: any): void {
    if (!data) return;
    const loginData = environment.ENCRYPT_LOCAL_STORAGE ? CryptoJS.AES.encrypt(JSON.stringify(data), environment.LOCAL_STORAGE_SECRET).toString() : JSON.stringify(data);
    localStorage.setItem('login response', loginData);
  }

  /**
   * get stored used data from localstorage
   * @return {JSON} returns user data
   */
  public getLoginData(): any {
    const item = localStorage.getItem('login response');
    if (!item || item === 'undefined' || item === 'null') return null;
    try {
      const loginData = environment.ENCRYPT_LOCAL_STORAGE ? CryptoJS.AES.decrypt(item, environment.LOCAL_STORAGE_SECRET).toString(CryptoJS.enc.Utf8) : item;
      if (!loginData || loginData === 'undefined' || loginData === 'null') return null;
      return JSON.parse(loginData);
    } catch (e) {
      console.error('Error parsing login data', e);
      return null;
    }
  }

  /**
   * store any data
   *
   * @param {string} key
   * @param {any} value
   */
  public storeData(key: string, value: any): void {
    const data = environment.ENCRYPT_LOCAL_STORAGE ? CryptoJS.AES.encrypt(JSON.stringify(value), environment.LOCAL_STORAGE_SECRET).toString() : JSON.stringify(value);
    localStorage.setItem(key, data);
  }

  /**
   * Get localstorage value by key
   *
   * @param {string} key
   * @return {any}
   */
  public getDataByKey(key: string): any {
    const item = localStorage.getItem(key);
    if (!item || item === 'undefined' || item === 'null') return null;
    try {
      const data = environment.ENCRYPT_LOCAL_STORAGE ? CryptoJS.AES.decrypt(item, environment.LOCAL_STORAGE_SECRET).toString(CryptoJS.enc.Utf8) : item;
      if (!data || data === 'undefined' || data === 'null') return null;
      return JSON.parse(data);
    } catch (e) {
      console.error(`Error parsing data for key: ${key}`, e);
      return null;
    }
  }

  /**
   * Params local storage service
   * @param {string}key
   */
  public clearLocalStorage(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Clears all storage
   */
  public clearAllStorage() {
    localStorage.clear();
  }

  /**
* Sets token
* @param token 
*/

  setToken(token: string): void {
    localStorage.setItem('accessToken', token);
  }

  /**
   * Gets token
   * @returns token 
   */
  getToken(): string | null {
    return localStorage.getItem('accessToken');
  }

  /**
   * Removes token
   * @returns  
   */
  removeToken() {
    return localStorage.removeItem('accessToken');
  }

  /**
   * Clears specific local storage items
   * 
   * This function is used to clear local storage items that are specific to the application
   * such as the wagmi store, wallet address, referral id, user details, user id, wagmi connected status, 
   * has visited status, wagmi wallet and wallet connected status.
   */
  clearSpecificStorage(): void {
    localStorage.removeItem('wagmi.store');
    localStorage.removeItem('walletAddress');
    localStorage.removeItem('refId');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('user_id');
    localStorage.removeItem('wagmi.connected');
    localStorage.removeItem('hasVisited');
    localStorage.removeItem('wagmi.wallet');
    localStorage.removeItem('walletConnected');
  }

}
